import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import Sidebar from './Sidebar';
import Header from './Header';
import ErrorBoundary from '../ErrorBoundary';
import { auditService } from '../../services/audit.service';

function AppShell() {
  const location = useLocation();

  useEffect(() => {
    const screen = location.pathname === '/' ? 'dashboard' : location.pathname.slice(1);
    auditService.logScreenView(screen);
  }, [location.pathname]);

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto overflow-x-hidden p-6">
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
    </div>
  );
}

export default AppShell;
